import { Search, X } from 'lucide-react';

export default function SearchInput({ value, onChange, onClear }) {
    return (
        <div className="relative">
            <Search
                className="absolute top-1/2 left-5 size-5 -translate-y-1/2 text-muted-foreground"
                aria-hidden="true"
            />

            <input
                autoFocus
                type="search"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                placeholder="Search products, collections, categories..."
                aria-label="Search store"
                className="h-16 w-full rounded-3xl border border-border bg-white px-14 text-base transition outline-none focus:ring-2 focus:ring-ring [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none"
            />

            {value && (
                <button
                    type="button"
                    onClick={onClear}
                    aria-label="Clear search"
                    className="absolute top-1/2 right-5 -translate-y-1/2 rounded-full p-1 text-muted-foreground transition hover:bg-neutral-100 hover:text-foreground focus:ring-2 focus:ring-ring focus:outline-none"
                >
                    <X className="size-5" />
                </button>
            )}
        </div>
    );
}
